import { useSettings } from '../context/SettingsContext';
import PageWrapper from '../components/PageWrapper';
import Reveal from '../components/Reveal';
import { Link } from 'react-router-dom';

export default function About() {
  const { settings } = useSettings();
  const s = settings || {};
  const stats = s.aboutStats || [];

  return (
    <PageWrapper>
      <section className="section">
        <div className="container">
          <span className="eyebrow">Who we are</span>
          <h1 className="section-title">{s.aboutTitle || 'About Us'}</h1>

          <div className="grid grid-2" style={{ alignItems: 'center', marginTop: 20, gap: 46 }}>
            <Reveal>
              <p className="prose">{s.aboutContent || 'We craft products and services with care.'}</p>
              <Link to="/contact" className="btn btn-primary mt-2">Work with us</Link>
            </Reveal>
            {s.aboutImage && (
              <Reveal delay={0.1} className="gallery__main" style={{ aspectRatio: '4/3' }}>
                <img src={s.aboutImage} alt="About" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              </Reveal>
            )}
          </div>

          {stats.length > 0 && (
            <div className="grid grid-4" style={{ marginTop: 60 }}>
              {stats.map((st, i) => (
                <Reveal key={i} delay={i * 0.08} className="feature glass">
                  <h2 className="text-gradient" style={{ fontSize: 40 }}>{st.value}</h2>
                  <p>{st.label}</p>
                </Reveal>
              ))}
            </div>
          )}
        </div>
      </section>
    </PageWrapper>
  );
}
